import bottomRightDo from "../../../../../../packages/design-system/modal-dialog/constellation/images/Do-Align-buttons-bottom-right.png";
import bottomRightDont from "../../../../../../packages/design-system/modal-dialog/constellation/images/Dont-Align-buttons-bottom-right.png";
import focusDo from "../../../../../../packages/design-system/modal-dialog/constellation/images/Do-Keep-content-simple-and-focused.png";
import focusDont from "../../../../../../packages/design-system/modal-dialog/constellation/images/Dont-Keep-content-simple-and-focused.png";
import nestingDo from "../../../../../../packages/design-system/modal-dialog/constellation/images/Do-Nesting.png";
import nestingDont from "../../../../../../packages/design-system/modal-dialog/constellation/images/Dont-Nesting.png";
import * as React from 'react';
export default {
  bottomRightDo,
  bottomRightDont,
  focusDo,
  focusDont,
  nestingDo,
  nestingDont,
  React
};